import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/LP/MobileAppDevelopment'

const MobileAppDevelopment: React.FC = () => {
  return (
    <>
      <CustomHead
        keyword={'スマホアプリ開発 モバイルアプリ開発 アプリ開発 UX/UIデザイン'}
        image={'https://www.i3design.jp/img/ogp_mobile_app_development.png'}
        url={'https://www.i3design.jp/services/mobile-app-development/'}
        title="スマホアプリ開発 | i3DESIGN アイスリーデザイン"
        description="企画設計・UX/UIデザインからアプリ開発・運用まで、一気通貫でのご支援。リリース後のビジネス成長を見据えたモバイルアプリ開発は、アイスリーデザインにお任せください。"
      />
      <Template />
    </>
  )
}

export default MobileAppDevelopment
